import Popup from "../../../components/Popup/Popup"
import useStrings from "../../../localization/useStrings"
import Svg from "../../../utils/svg"
import styles from "./LifetimeDisclaimerPopup.module.scss"

interface Props {
  visible: boolean
  onClose: () => void
}

const LifetimeDisclaimerPopup = ({ visible, onClose }: Props) => {
  const strings = useStrings()

  return (
    <Popup
      title="Cloud Vault Details"
      ctaTitle={strings.gotIt}
      visible={visible}
      headerIcon={<Svg.PremiumIcon className={styles.icon} />}
      className={styles.popup}
      onClose={onClose}
    >
      <div className={styles.content}>
        <div className={styles.section}>
          <label className={styles.subtitle}>
            {strings.bubbleExpiration.lifetimeDisclaimerCloudStorage}
          </label>
        </div>
        <div className={styles.section}>
          <label className={styles.subtitle}>
            {strings.bubbleExpiration.lifetimeDisclaimerAfterPeriod}
          </label>
        </div>
        <div className={styles.section}>
          <label className={styles.subtitle}>
            <strong>
              {strings.bubbleExpiration.lifetimeDisclaimerPremiumFeatures}
            </strong>
          </label>
        </div>
      </div>
    </Popup>
  )
}

export default LifetimeDisclaimerPopup
